module.exports = __webpack_public_path__ + "img/image15.d53a1041.jpg";